// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".exp-section{width:100%;padding:0;background:#fff}.exp-section .section-header{min-height:40px;-webkit-user-select:none;-moz-user-select:none;user-select:none}.exp-section .section-header>.fw-heavy:first-child{font-size:1em;white-space:pre}.exp-section .section-header>.fw-heavy:first-child.inactive-section{color:#ccc}@media only screen and (max-width:1000px){.exp-section .section-header{flex-wrap:wrap;gap:12px}}", ""]);
// Exports
module.exports = exports;
